export default "__VITE_ASSET__3pzx1J_G__"